import {
  HIGHLIGHT_TODO,
  // UNHIGHLIGHT_TODO,
  BEGIN_INITIALIZATION,
  INITIALIZE_VIEW_TYPE,
  ADD_FIRESTORE_UNLISTENER,
  COMPLETE_LIST_INFO_LOAD,
  COMPLETE_TODO_ITEM_LOAD,
  END_INITIALIZATION,
  CLEAR_ALL,
  SET_TITLE_VIA_FIREBASE,
  SET_DESCRIPTION_VIA_FIREBASE,
  ADD_TODO_VIA_FIREBASE,
  MODIFY_TODO_VIA_FIREBASE,
  REMOVE_TODO_VIA_FIREBASE
} from '../actions/actionTypes'

export function highlightTodo (index) {
  return {
    type: HIGHLIGHT_TODO,
    index
  }
}

// export function unhighlightTodo(){
//   return {
//     type: UNHIGHLIGHT_TODO,
//   };
// }

export function beginInitialization (listId) {
  return {
    type: BEGIN_INITIALIZATION,
    listId
  }
}

export function initializeViewType (viewType) {
  return {
    type: INITIALIZE_VIEW_TYPE,
    viewType
  }
}

export function addFirestoreUnlistener (unlistener) {
  return {
    type: ADD_FIRESTORE_UNLISTENER,
    unlistener
  }
}

export function completeListInfoLoad () {
  return {
    type: COMPLETE_LIST_INFO_LOAD
  }
}

export function completeTodoItemLoad () {
  return {
    type: COMPLETE_TODO_ITEM_LOAD
  }
}

export function endTodoInitialization () {
  return {
    type: END_INITIALIZATION
  }
}

export function clearAll () {
  return {
    type: CLEAR_ALL
  }
}

export function setTitleViaFirebase (title) {
  return {
    type: SET_TITLE_VIA_FIREBASE,
    title
  }
}

export function setDescriptionViaFirebase (description) {
  return {
    type: SET_DESCRIPTION_VIA_FIREBASE,
    description
  }
}

export function addTodoViaFirebase (todo) {
  return {
    type: ADD_TODO_VIA_FIREBASE,
    todo
  }
}

export function modifyTodoViaFirebase (todo) {
  return {
    type: MODIFY_TODO_VIA_FIREBASE,
    todo
  }
}

export function removeTodoViaFirebase (todo) {
  return {
    type: REMOVE_TODO_VIA_FIREBASE,
    todo
  }
}



// WEBPACK FOOTER //
// ./src/actions/actionCreators.js